<template>
    <div>
        <div class="title-bar">

            <h1>{{ $t('oscilos_view.title') }}</h1>

            <div class="d-flex gap-2">
                <DxSelectBox :data-source="tiposPantalla" display-expr="Nombre" value-expr="Id"
                    :value="tipoPantallaDestino" @value-changed="onTipoPantallaChange">
                    <template #item-template="{ data }">
                        <i :class="data.icon" aria-hidden="true"></i>
                        {{ data.Nombre }}
                    </template>
                </DxSelectBox>

                <DxButton v-bind="updateButtonProps()" @click="cargarOscilos" />
            </div>
        </div>

        <RejillaOscilos :oscilosProp="oscilos" :vistaAdministracionProp="false" v-if="gridVisible">
        </RejillaOscilos>
        <MapaOscilos :oscilosProp="oscilos" v-if="mapaVisible"></MapaOscilos>
        <CuadriculaOscilos :oscilosProp="oscilos" v-if="cuadriculaVisible"></CuadriculaOscilos>
    </div>
</template>

<script setup lang="ts">
import { useIntl } from '@services/i18n'
import { DxButton } from 'devextreme-vue';
import { onMounted, ref, watch } from 'vue';
import { useApi } from '@/.shared/.api/integration';
import { DxSelectBox } from 'devextreme-vue/select-box';
import type { OsciloDetalleModel } from '@/.shared/.api';
import { updateButtonProps } from '@helpers/button-helper';
import MapaOscilos from '@/components/oscilos/MapaOscilos.vue';
import { useRoute, type LocationQueryValue } from 'vue-router';
import { useRouter } from '@/.shared/services/routing-services';
import type { ValueChangedEvent } from 'devextreme/ui/select_box';
import RejillaOscilos from '@/components/oscilos/RejillaOscilos.vue';
import CuadriculaOscilos from '@/components/oscilos/CuadriculaOscilos.vue';

const api = useApi();
const intl = useIntl();
const route = useRoute();
const router = useRouter();

enum TipoPantalla {
    Mapa = 1,
    Cuadricula = 2,
    Rejilla = 3
}

const tiposPantalla = ref([
    { Id: TipoPantalla.Mapa, Nombre: intl.i18n.t('oscilos.tipos_pantalla.mapa'), icon: 'fa-regular fa-map icono-selector' },
    { Id: TipoPantalla.Cuadricula, Nombre: intl.i18n.t('oscilos.tipos_pantalla.cuadricula'), icon: 'fa-regular fa-grid icono-selector' },
    { Id: TipoPantalla.Rejilla, Nombre: intl.i18n.t('oscilos.tipos_pantalla.rejilla'), icon: 'fa-regular fa-grid-horizontal icono-selector' }
]);
let oscilos = ref<OsciloDetalleModel[]>([]);  // cuando cambie el .value de cada ref, los que estén escuchando ese ref, se enteran y se refrescan
let mapaVisible = ref<boolean>(false);
let cuadriculaVisible = ref<boolean>(false);
let gridVisible = ref<boolean>(false);
let tipoPantallaDestino = ref(TipoPantalla.Mapa);

onMounted(() => { // onMounted: cuando estan todos los componentes preparados.
    watch(
        () => route.query.tipoPantalla,
        async (newTipoPantalla: LocationQueryValue | LocationQueryValue[]) => {
            if (newTipoPantalla != null)
                tipoPantallaDestino.value = parseInt(newTipoPantalla as string) as TipoPantalla;

            // Si el id de la URL no está entre los valores del enum, mostramos el mapa:
            if (tipoPantallaDestino.value < TipoPantalla.Mapa || tipoPantallaDestino.value > TipoPantalla.Rejilla)
                tipoPantallaDestino.value = TipoPantalla.Mapa;

            mapaVisible.value = tipoPantallaDestino.value == TipoPantalla.Mapa;
            cuadriculaVisible.value = tipoPantallaDestino.value == TipoPantalla.Cuadricula;
            gridVisible.value = tipoPantallaDestino.value == TipoPantalla.Rejilla;
        },
        { immediate: true }
    );
});


await cargarOscilos();

async function cargarOscilos(): Promise<void> {
    let oscilosResult = await api.callStandardApi('osciloGetRejilla', {});
    oscilos.value = oscilosResult.data!;
}

async function onTipoPantallaChange(ev: ValueChangedEvent): Promise<void> {
    var tipoPantalla = ev.value as TipoPantalla;
    router.push(intl.i18Route({ name: "oscilos-view", query: { tipoPantalla: tipoPantalla } }));
}
</script>

<style lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";
</style>